<div class="title"><span>{{ effectiveness }} Effective</span>Resource Allocation Scores</div>
<div class="boxes">
  <app-q-effective-box
    [type]="data[0].type"
    [feedback]="data[0].title"
  ></app-q-effective-box>
  <app-q-effective-box
    [type]="data[1].type"
    [feedback]="data[1].title"
  ></app-q-effective-box>
</div>